import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "../store";
import type { Broadcast } from "../../types/broadcasts.types";

const broadcastStateSelector = (state: RootState) => state.broadcast;

export const selectHomeTeam = createSelector(
	broadcastStateSelector,
	(broadcast) => broadcast.homeTeam,
);

export const selectAwayTeam = createSelector(
	broadcastStateSelector,
	(broadcast) => broadcast.awayTeam,
);

export const selectHomeLogo = createSelector(
	broadcastStateSelector,
	(broadcast) => broadcast.homeLogo,
);

export const selectAwayLogo = createSelector(
	broadcastStateSelector,
	(broadcast) => broadcast.awayLogo,
);

export const selectVenue = createSelector(
	broadcastStateSelector,
	(broadcast) => broadcast.venue,
);

export const selectLocation = createSelector(
	broadcastStateSelector,
	(broadcast) => broadcast.location,
);

export const selectFixtureDate = createSelector(
	broadcastStateSelector,
	(broadcast) => broadcast.fixtureDate,
);

export const selectBroadcastId = createSelector(
	broadcastStateSelector,
	(broadcast) => broadcast.broadcastId,
);

export const selectBroadcastUserId = createSelector(
	broadcastStateSelector,
	(broadcast) => broadcast.broadcastUserId,
);

export const selectStartTime = createSelector(
	broadcastStateSelector,
	(broadcast) => broadcast.startTime,
);

export const selectFixtureId = createSelector(
	broadcastStateSelector,
	(broadcast) => broadcast.fixtureId,
);

export const selectHalfTimeAt = createSelector(
	broadcastStateSelector,
	(broadcast) => broadcast.halfTimeAt,
);

export const selectSecondHalfStartTime = createSelector(
	broadcastStateSelector,
	(broadcast) => broadcast.secondHalfStartTime,
);

export const selectFullTimeAt = createSelector(
	broadcastStateSelector,
	(broadcast) => broadcast.fullTimeAt,
);

export const selectHashtagInput = createSelector(
	broadcastStateSelector,
	(broadcast) => broadcast.hashtagInput,
);

export const selectTimeCorrection = createSelector(
	broadcastStateSelector,
	(broadcast) => broadcast.timeCorrection,
);

// Bundles the fields FeedHeader needs into one object so callers don't have
// to wire up a dozen individual useSelector calls just to render it.
export const selectFeedHeaderData = createSelector(
	broadcastStateSelector,
	(broadcast): Pick<
		Broadcast,
		| "homeTeam"
		| "awayTeam"
		| "homeLogo"
		| "awayLogo"
		| "venue"
		| "location"
		| "fixtureDate"
		| "startTime"
		| "halfTimeAt"
		| "secondHalfStartTime"
		| "fullTimeAt"
		| "timeCorrection"
	> => ({
		homeTeam: broadcast.homeTeam,
		awayTeam: broadcast.awayTeam,
		homeLogo: broadcast.homeLogo,
		awayLogo: broadcast.awayLogo,
		venue: broadcast.venue,
		location: broadcast.location,
		fixtureDate: broadcast.fixtureDate,
		startTime: broadcast.startTime,
		halfTimeAt: broadcast.halfTimeAt,
		secondHalfStartTime: broadcast.secondHalfStartTime,
		fullTimeAt: broadcast.fullTimeAt,
		timeCorrection: broadcast.timeCorrection,
	}),
);

export const selectIsMatchInProgress = createSelector(
	broadcastStateSelector,
	(broadcast) =>
		Boolean(broadcast.startTime) &&
		!broadcast.fullTimeAt &&
		(!broadcast.halfTimeAt || Boolean(broadcast.secondHalfStartTime)),
);
